/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_And_Connect_DomainInputs */

const en_verify_and_connect_domain = /** @type {(inputs: Verify_And_Connect_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify & Connect Domain`)
};

const es_verify_and_connect_domain = /** @type {(inputs: Verify_And_Connect_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificar y conectar dominio`)
};

const fr_verify_and_connect_domain = /** @type {(inputs: Verify_And_Connect_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifier et Connecter le Domaine`)
};

const de_verify_and_connect_domain = /** @type {(inputs: Verify_And_Connect_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain überprüfen & verbinden`)
};

const ja_verify_and_connect_domain = /** @type {(inputs: Verify_And_Connect_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドメインを検証して接続`)
};

const zh_verify_and_connect_domain = /** @type {(inputs: Verify_And_Connect_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证并连接域名`)
};

const ar_verify_and_connect_domain = /** @type {(inputs: Verify_And_Connect_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التحقق وربط النطاق`)
};

const id_verify_and_connect_domain = /** @type {(inputs: Verify_And_Connect_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifikasi & Hubungkan Domain`)
};

const it_verify_and_connect_domain = /** @type {(inputs: Verify_And_Connect_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica & Connetti Dominio`)
};

const ru_verify_and_connect_domain = /** @type {(inputs: Verify_And_Connect_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверить и подключить домен`)
};

const pt_verify_and_connect_domain = /** @type {(inputs: Verify_And_Connect_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificar e Conectar Domínio`)
};

const ko_verify_and_connect_domain = /** @type {(inputs: Verify_And_Connect_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도메인 검증 및 연결`)
};

/**
* | output |
* | --- |
* | "Verify & Connect Domain" |
*
* @param {Verify_And_Connect_DomainInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_and_connect_domain = /** @type {((inputs?: Verify_And_Connect_DomainInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_And_Connect_DomainInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_and_connect_domain(inputs)
	if (locale === "es") return es_verify_and_connect_domain(inputs)
	if (locale === "fr") return fr_verify_and_connect_domain(inputs)
	if (locale === "de") return de_verify_and_connect_domain(inputs)
	if (locale === "ja") return ja_verify_and_connect_domain(inputs)
	if (locale === "zh") return zh_verify_and_connect_domain(inputs)
	if (locale === "ar") return ar_verify_and_connect_domain(inputs)
	if (locale === "id") return id_verify_and_connect_domain(inputs)
	if (locale === "it") return it_verify_and_connect_domain(inputs)
	if (locale === "ru") return ru_verify_and_connect_domain(inputs)
	if (locale === "pt") return pt_verify_and_connect_domain(inputs)
	return ko_verify_and_connect_domain(inputs)
});